import React from 'react';
import { motion } from 'framer-motion';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ArticleCard = ({ article, index, onReadMore }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1, duration: 0.5 }}
      className="bg-slate-900/50 backdrop-blur-xl rounded-2xl overflow-hidden border border-teal-500/20 hover:border-teal-500/60 transition-all duration-300 group cursor-pointer shadow-lg hover:shadow-2xl hover:shadow-teal-500/30 hover:-translate-y-2"
      onClick={() => onReadMore(article)}
    >
      {/* Image */}
      <div className="relative h-56 md:h-64 overflow-hidden">
        <Image
          src={article?.image}
          alt={article?.imageAlt}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent" />
        <div className="absolute top-4 left-4">
          <span className="px-4 py-1.5 bg-gradient-to-r from-teal-500 to-cyan-500 text-white text-xs font-bold rounded-full shadow-lg shadow-teal-500/50">
            {article?.category}
          </span>
        </div>
      </div>
      {/* Content */}
      <div className="p-6">
        {/* Meta Info */}
        <div className="flex items-center gap-4 mb-4 text-xs text-slate-400">
          <div className="flex items-center gap-1.5">
            <Icon name="Calendar" size={14} color="#14b8a6" />
            <span>{article?.publishDate}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <Icon name="Clock" size={14} color="#14b8a6" />
            <span>{article?.readTime} min</span>
          </div>
        </div>

        {/* Title */}
        <h3 className="text-xl font-bold mb-3 text-white line-clamp-2 group-hover:text-teal-400 transition-colors leading-tight">
          {article?.title}
        </h3>

        {/* Excerpt */}
        <p className="text-sm text-slate-400 mb-5 line-clamp-3 leading-relaxed">
          {article?.excerpt}
        </p>

        {/* Footer */}
        <div className="flex items-center justify-between pt-5 border-t border-teal-500/20">
          <div className="flex items-center gap-3">
            <Image
              src={article?.author?.avatar}
              alt={article?.author?.avatarAlt}
              className="w-9 h-9 rounded-full object-cover border-2 border-teal-500/50"
            />
            <span className="text-sm font-semibold text-slate-300">
              {article?.author?.name}
            </span>
          </div>

          <div className="flex items-center gap-4 text-slate-400">
            <div className="flex items-center gap-1.5">
              <Icon name="Eye" size={16} color="#14b8a6" />
              <span className="text-xs font-medium">{article?.views}</span>
            </div>
            <div className="flex items-center gap-1.5">
              <Icon name="MessageCircle" size={16} color="#14b8a6" />
              <span className="text-xs font-medium">{article?.comments}</span>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ArticleCard;